import { getConfigValue } from '@/helpers/configHelper';

import Cookies from 'js-cookie';

const cookiePrefix = getConfigValue('cookiePrefix');
const domain = getConfigValue('cloverSportDomain');

export const cookieService = {
  cookieOptions: {
    path: '/',
    secure: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'integration',
    sameSite: 'strict',
    domain: `.${domain}`,
    expires: new Date(Date.now() + 24 * 60 * 60 * 1000) // 24 hours expiration
  },

  getCookie: (name) => {
    const prefixedName = `${cookiePrefix}__${name}`;
    const value = Cookies.get(prefixedName, cookieService.cookieOptions);
    let parsedValue = null;
    if (!value) {
      return null;
    }

    parsedValue = name === 'venue_ids' ? JSON.parse(value) : value;
    return parsedValue;
  },

  setCookie: (name, value) => {
    const prefixedName = `${cookiePrefix}__${name}`;
    let derivedValue = value;
    if (name === 'venue_ids') {
      derivedValue = JSON.stringify(value);
    }
    Cookies.set(prefixedName, derivedValue, cookieService.cookieOptions);
  },

  removeCookie: (name) => {
    const prefixedName = `${cookiePrefix}__${name}`;
    Cookies.remove(prefixedName, cookieService.cookieOptions);
  }
};
